import { Car, ParkingCircle, TrainFront } from "lucide-react";
import { useLanguage } from "./LanguageContext";
import { Reveal } from "./Reveal";
import { WEDDING } from "./config";
import { CornerOrnament, IznikTexture } from "./Motifs";

export default function TravelSection() {
  const { t } = useLanguage();
  const cards = [
    { icon: Car, title: t.travel.carTitle, desc: t.travel.carDesc },
    { icon: ParkingCircle, title: t.travel.parkingTitle, desc: t.travel.parkingDesc },
    { icon: TrainFront, title: t.travel.transitTitle, desc: t.travel.transitDesc },
  ];

  return (
    <section
      data-testid="travel-section"
      className="relative bg-cream py-24 md:py-32"
    >
      <IznikTexture size={320} />
      <div className="relative z-10 mx-auto max-w-6xl px-6 md:px-10">
        <Reveal>
          <span className="font-sans text-xs uppercase tracking-[0.28em] text-pinky">
            05 — {t.travel.kicker}
          </span>
          <h2 className="mt-4 font-display text-4xl md:text-6xl tracking-tight text-ink">
            {t.travel.title}
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
          {/* info cards */}
          <div className="lg:col-span-5 flex flex-col gap-4">
            {cards.map((c, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="flex items-start gap-4 rounded-sm border border-gold/30 bg-white p-5">
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-blush/25 text-turq">
                    <c.icon className="h-5 w-5" strokeWidth={1.6} />
                  </span>
                  <div>
                    <h3 className="font-display text-2xl text-ink">{c.title}</h3>
                    <p className="mt-1 font-sans text-sm leading-relaxed text-ink/65">
                      {c.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          {/* embedded map */}
          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="relative h-full min-h-[340px] overflow-hidden rounded-sm border border-gold/40">
              <CornerOrnament className="absolute left-2 top-2 z-10 w-10" />
              <CornerOrnament className="absolute right-2 top-2 z-10 w-10 rotate-90" />
              <CornerOrnament className="absolute bottom-2 right-2 z-10 w-10 rotate-180" />
              <CornerOrnament className="absolute bottom-2 left-2 z-10 w-10 -rotate-90" />
              <iframe
                title="Park de Heerlijkheid kaart"
                data-testid="map-embed"
                src={WEDDING.mapsEmbedUrl}
                className="h-full w-full min-h-[340px]"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
